import { render, staticRenderFns } from "./column-authorize.vue?vue&type=template&id=6fb1c55e&scoped=true"
import script from "./column-authorize.vue?vue&type=script&lang=js"
export * from "./column-authorize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb1c55e",
  null
  
)

export default component.exports